import "./Brand.scss";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { env } from "../../env/env";
import BrandKitIcon from "../icons/BrandKitIcon";
import { memberState } from "../../state/atoms";

export default function Brand() {
  const navigate = useNavigate();
  const member = useRecoilValue(memberState);
  const canManageBrand =
    !!member && (member.owner || member.role === "Admin" || (member as any).manageBrand);

  return (
    <div className="brand-relocated page">
      <div className="brand-relocated-card">
        <div className="brand-relocated-icon">
          <BrandKitIcon />
        </div>
        <h2>Brand has a new home</h2>
        <p>
          Brand Kits, logos, colors, fonts, and Brand Templates are now managed in
          Account Settings. Owners and admins have full access — other users can be
          granted access via the Manage Brand permission.
        </p>
        {canManageBrand && (
          <Button
            type="primary"
            size="large"
            className="brand-relocated-cta"
            onClick={() => navigate(`${env.dashboardPath}/account/brand-management`)}
          >
            Go to Brand Management
          </Button>
        )}
        <p className="brand-relocated-hint">
          Not an owner or admin? Ask your account owner to grant you Manage Brand
          access in Team settings.
        </p>
      </div>
    </div>
  );
}
